import './modalAcceptCookies.scss';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateCookies, updateCookiesAnaliticas } from 'redux/slices/permissionSlice';
import Button from 'components/commons/buttons/button/Button';
import CheckBox from 'components/commons/inputs/checkbox/CheckBox';
import { useLanguage, useTranslate } from 'context/languageContext';
import { Link } from 'react-router-dom';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';

export default function ModalAcceptCookies() {
  const [showCookiesTecnicas, setshowCookiesTecnicas] = useState(false);
  const [showCookiesAnaliticas, setShowCookiesAnaliticas] = useState(false);
  const [cookiesAnaliticas, setCookiesAnaliticas] = useState(false);
  const t = useTranslate();
  const locale = useLanguage();

  const dispatch = useDispatch();

  const acceptAllCookies = () => {
    dispatch(updateCookiesAnaliticas(true));
    dispatch(updateCookies());
  };

  const acceptSelectedCookies = () => {
    dispatch(updateCookiesAnaliticas(cookiesAnaliticas));
    dispatch(updateCookies());
  };

  return (
    <div className='modalAcceptCookies' style={{overflow: 'auto'}}>
      <h1 className='titulo'>{t('lb_cookies_banner_title')}</h1>
      <div style={{ marginBlockEnd: '1em'}}>
        {t('lb_cookies_banner_intro1')}
        <b>{' ' + t('lb_cookies_banner_intro2')}</b>{' '}
        <Link
          style={{
            color: '#006eb7',
            textDecorationLine: 'underline',
            textDecorationColor: '#006eb7',
            textDecorationStyle: 'solid',
          }}
          to={`/${locale}/${RUTAS_GENERALES_MUL2.cookiesPolicy[locale]}`}
        >
          {t('lb_cookies_read_more')}
        </Link>
      </div>

      <h2 className='subTitulo'>
        <form className='formularioAcceptCookies'>
          {/* <input
            type='checkbox'
            name='coockies_analitics'
            className='inputAcceptCookies'
            aria-checked={true}
            checked
            disabled
          />{' '} */}
          <CheckBox
            name={'technical_cookies'}
            etiqueta={''}
            checked
            disabled
            onChange={() => null}
            value={true}
          />
          <span>
            {t('lb_cookies_banner_technic_title')} (<u>{t('lb_cookies_banner_need')}</u>)
          </span>
        </form>
      </h2>
      <div className='formText'>{t('lb_cookies_banner_technic_desc')}</div>

      <p onClick={() => setshowCookiesTecnicas(!showCookiesTecnicas)} className='linkVerDetalle'>
        {showCookiesTecnicas ? t('lb_cookies_banner_hide') : t('lb_cookies_banner_view')}{' '}
        {t('lb_cookies_banner_list_cookies')}
      </p>
      {showCookiesTecnicas && (
        <table className='tablaTipo3'>
          <tbody>
            <tr>
              <th>
                <strong>{t('lb_cookies_banner_denomi')}</strong>
              </th>
              <th>
                <strong>{t('lb_cookies_banner_origin')}</strong>
              </th>
              <th>
                <strong>{t('lb_cookies_banner_duration')}</strong>
              </th>
              <th>
                <strong>{t('lb_cookies_banner_purpose')}</strong>
              </th>
            </tr>
            <tr>
              <td>EmtPalmaCookie</td>
              <td>EmtPalma</td>
              <td>{t('lb_cookies_banner_persist')}</td>
              <td>{t('lb_cookies_banner_technic_table_purpose1')}</td>
            </tr>
            <tr>
              <td>LAST_LOCALE</td>
              <td>EmtPalma</td>
              <td>{t('lb_cookies_banner_persist')}</td>
              <td>{t('lb_cookies_banner_technic_table_purpose2')}</td>
            </tr>
          </tbody>
        </table>
      )}

      <h2 className='subTitulo'>
        <form className='formularioAcceptCookies'>
          {/* <input
            type='checkbox'
            name='coockies_analitics'
            className='inputAcceptCookies'
            aria-checked={cookiesAnaliticas}
            checked={cookiesAnaliticas}
            onChange={() => setCookiesAnaliticas(!cookiesAnaliticas)}
          />{' '} */}
          <CheckBox
            name={'analitics_cookies'}
            etiqueta={''}
            onChange={() => setCookiesAnaliticas(!cookiesAnaliticas)}
            checked={cookiesAnaliticas}
            value={'analitics_cookies'}
          />
          <span>{t('lb_cookies_banner_analytics_title')}</span>
        </form>
      </h2>

      <div className='formText'>{t('lb_cookies_banner_analytics_desc')}</div>
      <p
        onClick={() => setShowCookiesAnaliticas(!showCookiesAnaliticas)}
        className='linkVerDetalle'
      >
        {showCookiesAnaliticas ? t('lb_cookies_banner_hide') : t('lb_cookies_banner_view')}{' '}
        {t('lb_cookies_banner_list_cookies')}
      </p>
      {showCookiesAnaliticas && (
        <table className='tablaTipo3'>
          <tbody>
            <tr>
              <th>
                <strong>{t('lb_cookies_banner_denomi')}</strong>
              </th>
              <th>
                <strong>{t('lb_cookies_banner_origin')}</strong>
              </th>
              <th>
                <strong>{t('lb_cookies_banner_duration')}</strong>
              </th>
              <th>
                <strong>{t('lb_cookies_banner_purpose')}</strong>
              </th>
            </tr>
            <tr>
              <td>_ga</td>
              <td>Google</td>
              <td>{t('lb_cookies_banner_analytics_table_purpose1')}</td>
              <td>{t('lb_cookies_banner_analytics_table_purpose1_desc')}</td>
            </tr>
            <tr>
              <td>_ga_[UID]</td>
              <td>Google</td>
              <td>{t('lb_cookies_banner_analytics_table_purpose2_duration')}</td>
              <td>{t('lb_cookies_banner_analytics_table_purpose2')}</td>
            </tr>
          </tbody>
        </table>
      )}
      <div className='botonera'>
        <Button
          className='btn-all'
          title={t('lb_cookies_banner_accept_all')}
          onClick={() => acceptAllCookies()}
        />
        <Button
          className='btn-selected'
          title={t('lb_cookies_banner_accept_select')}
          onClick={() => acceptSelectedCookies()}
        />
      </div>
    </div>
  );
}
